// import { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import api from "../api/axiosInstance";
// import SkillOverrideModal from "../components/SkillOverrideModal";
// import {
//   fetchOptimizationById,
//   resolveEligibility,
//   updateSkillSelection,
//   parseJd,
//   matchSkills,
//   generateTitleAlignment,
//   generateSummary,
//   generateExperience,
//   generateFinalResume,
//   fetchRuleStatus,
//   clearOptimizationError,
//   clearSelectedOptimization,
// } from "../slice/optimizationSlice";
// import { formatDateTime } from "../utils/formatters";
// import { findDraftLanguage } from "../utils/overrideDraftCheck";
// import ProjectsSection from "../components/ProjectsSection";
// import HighlightedBulletList, { AiChangesLegend } from "../components/HighlightedBulletList";
// import ScreeningPanel from "../components/ScreeningPanel";

// const STATUS_COLORS = {
//   ELIGIBLE: { bg: "#e6f4ea", fg: "#1e7e34" },
//   NEEDS_REVIEW: { bg: "#fff8e1", fg: "#8a6d00" },
//   DISQUALIFIED: { bg: "#fdecea", fg: "#b3261e" },
//   PENDING: { bg: "#f4f5f7", fg: "#5a5a5a" },
// };

// const FACTOR_LABELS = {
//   skillsMatch: "Skills Match",
//   experienceMatch: "Experience Match",
//   titleAlignment: "Title Alignment",
//   industryFit: "Industry Fit",
//   resumeQuality: "Resume Quality",
// };

// // Shared card shell used across the summary row, rule engine grid, and
// // final ATS comparison row.
// const CARD_STYLE = {
//   border: "1px solid #e0e0e0",
//   borderRadius: "6px",
//   padding: "14px 16px",
//   backgroundColor: "#fff",
//   height: "100%",
//   boxSizing: "border-box",
// };

// // Fixed-size button style for the section panel's header action.
// const SECTION_ACTION_BUTTON_STYLE = { padding: "6px 14px", fontSize: "13px", minWidth: "190px", textAlign: "center" };

// // One tile in the section slider. `role` is "center" (the active
// // section, shown larger/prominent) or "side" (a neighboring section,
// // shown smaller and faded — a "peek" the user can click to jump to it).
// function SliderTile({ title, role, onClick }) {
//   const isCenter = role === "center";
//   return (
//     <div
//       role="button"
//       tabIndex={0}
//       onClick={onClick}
//       onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
//       style={{
//         cursor: "pointer",
//         flex: isCenter ? "0 0 300px" : "0 0 200px",
//         padding: isCenter ? "20px 22px" : "16px 18px",
//         borderRadius: "12px",
//         border: isCenter ? "2px solid #1a4d8f" : "1px solid #e0e0e0",
//         backgroundColor: "#fff",
//         boxShadow: isCenter ? "0 6px 18px rgba(0,0,0,0.10)" : "0 1px 3px rgba(0,0,0,0.05)",
//         opacity: isCenter ? 1 : 0.65,
//         transform: isCenter ? "scale(1)" : "scale(0.9)",
//         transition: "all 0.2s ease",
//         textAlign: "center",
//         userSelect: "none",
//       }}
//     >
//       <div style={{ fontSize: isCenter ? "16px" : "13.5px", fontWeight: 600, color: isCenter ? "#1a4d8f" : "#5a5a5a" }}>
//         {title}
//       </div>
//     </div>
//   );
// }

// // Carousel strip: previous section (peek, left) — active section
// // (center, prominent) — next section (peek, right), with left/right
// // arrow buttons. Circular: past the last section wraps to the first.
// function SectionSlider({ sections, activeIndex, onSelect }) {
//   const len = sections.length;
//   const prevIndex = (activeIndex - 1 + len) % len;
//   const nextIndex = (activeIndex + 1) % len;

//   const arrowStyle = {
//     borderRadius: "50%",
//     width: "36px",
//     height: "36px",
//     padding: 0,
//     fontSize: "16px",
//     lineHeight: 1,
//     flexShrink: 0,
//   };

//   return (
//     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", padding: "50px 0", flexWrap: "wrap" }}>
//       <button type="button" onClick={() => onSelect(prevIndex)} aria-label="Previous section" style={arrowStyle}>
//         ‹
//       </button>
//       <SliderTile title={sections[prevIndex].title} role="side" onClick={() => onSelect(prevIndex)} />
//       <SliderTile title={sections[activeIndex].title} role="center" onClick={() => { }} />
//       <SliderTile title={sections[nextIndex].title} role="side" onClick={() => onSelect(nextIndex)} />
//       <button type="button" onClick={() => onSelect(nextIndex)} aria-label="Next section" style={arrowStyle}>
//         ›
//       </button>
//     </div>
//   );
// }

// // A tiny reusable "why this score?" expander.
// function ScoreReasoning({ breakdown }) {
//   if (!breakdown?.reasoning) return null;
//   return (
//     <details style={{ margin: "10px 0 0", fontSize: "13px", color: "#3a3a3a" }}>
//       <summary style={{ cursor: "pointer", fontWeight: "bold", color: "#1a4d8f" }}>Why this score?</summary>
//       <p style={{ margin: "6px 0 0" }}>{breakdown.reasoning}</p>
//     </details>
//   );
// }

// // Compact label/value pair used inside cards below.
// function InfoField({ label, value }) {
//   return (
//     <div>
//       <div style={{ fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.04em", color: "#5a5a5a", marginBottom: "3px" }}>
//         {label}
//       </div>
//       <div style={{ fontSize: "14px", color: "#1a1a1a" }}>{value}</div>
//     </div>
//   );
// }

// // Card-header label — small caps gray, used at the top of each summary card.
// function CardTitle({ children }) {
//   return (
//     <div style={{ fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.04em", color: "#5a5a5a", marginBottom: "12px" }}>
//       {children}
//     </div>
//   );
// }

// // Turns the raw eligibility inputs into a full checklist covering every
// // criterion the rule engine actually looks at.
// function buildEligibilityChecklist(opt) {
//   const ec = opt.jobDescription?.eligibilityConstraints || {};
//   const constraints = opt.eligibility?.constraints || [];
//   const workAuth = opt.candidateId?.workAuthorization;

//   const usCitizenViolation = constraints.find((c) => c.reason?.includes("US Citizenship is required"));
//   const greenCardViolation = constraints.find((c) => c.reason?.includes("Green Card / Permanent Resident status is required"));
//   const clearanceFlag = constraints.find((c) => c.rule === "RULE-EXT-CLEARANCE");
//   const otherFlag = constraints.find((c) => c.rule === "RULE-EXT-OTHER");
//   const domainFlag = constraints.find((c) => c.rule === "RULE-EXT-DOMAIN");

//   return [
//     {
//       criterion: "US Citizenship Required",
//       requiredLabel: ec.usCitizenshipRequired ? "Yes" : "No",
//       status: !ec.usCitizenshipRequired ? "NOT_REQUIRED" : usCitizenViolation ? "FAIL" : "PASS",
//       detail: !ec.usCitizenshipRequired
//         ? "Not a requirement for this role."
//         : usCitizenViolation
//           ? usCitizenViolation.reason
//           : `Candidate's work authorization (${workAuth || "on file"}) satisfies this requirement.`,
//     },
//     {
//       criterion: "Green Card / Permanent Resident Required",
//       requiredLabel: ec.greenCardRequired ? "Yes" : "No",
//       status: !ec.greenCardRequired ? "NOT_REQUIRED" : greenCardViolation ? "FAIL" : "PASS",
//       detail: !ec.greenCardRequired
//         ? "Not a requirement for this role."
//         : greenCardViolation
//           ? greenCardViolation.reason
//           : `Candidate's work authorization (${workAuth || "on file"}) satisfies this requirement.`,
//     },
//     {
//       criterion: "Security / Citizenship Clearance",
//       requiredLabel: ec.securityClearanceRequired ? "Yes" : "No",
//       status: !ec.securityClearanceRequired ? "NOT_REQUIRED" : "NOT_AUTOMATED",
//       detail: !ec.securityClearanceRequired
//         ? "Not a requirement for this role."
//         : clearanceFlag?.reason || "Clearance eligibility can't be verified automatically — confirm manually.",
//     },
//     {
//       criterion: "Other Client-Specific Requirement",
//       requiredLabel: ec.otherRequirement?.trim() ? ec.otherRequirement.trim() : "No",
//       status: !ec.otherRequirement?.trim() ? "NOT_REQUIRED" : "NOT_AUTOMATED",
//       detail: !ec.otherRequirement?.trim() ? "Not a requirement for this role." : otherFlag?.reason || "Please verify manually.",
//     },
//     {
//       criterion: "Candidate / Job Domain Fit",
//       requiredLabel: "\u2014",
//       status: domainFlag ? "FAIL" : "PASS",
//       detail: domainFlag ? domainFlag.reason : "Candidate's background appears to fit this role's field.",
//     },
//   ];
// }

// // A horizontal progress bar + number, used for individual factor scores.
// function ScoreBar({ value, size = "normal" }) {
//   const barColor = value == null ? "#e0e0e0" : value >= 75 ? "#1e7e34" : value >= 50 ? "#c9891a" : "#b3261e";
//   const height = size === "large" ? 14 : 8;
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//       <div style={{ flex: 1, height: `${height}px`, backgroundColor: "#eef0f2", borderRadius: `${height / 2}px`, overflow: "hidden" }}>
//         <div
//           style={{
//             width: `${value ?? 0}%`,
//             height: "100%",
//             backgroundColor: barColor,
//             borderRadius: `${height / 2}px`,
//             transition: "width 0.3s ease",
//           }}
//         />
//       </div>
//       <span
//         style={{
//           minWidth: size === "large" ? "70px" : "60px",
//           textAlign: "right",
//           fontSize: size === "large" ? "18px" : "13px",
//           fontWeight: size === "large" ? "bold" : "normal",
//           color: value == null ? "#8a8a8a" : "#1a1a1a",
//           fontStyle: value == null ? "italic" : "normal",
//         }}
//       >
//         {value == null ? "Not measured" : `${value}/100`}
//       </span>
//     </div>
//   );
// }

// // Circular ring gauge for a single 0-100 overall score.
// function CircularScore({ value, size = 90 }) {
//   const stroke = 8;
//   const radius = (size - stroke) / 2;
//   const circumference = 2 * Math.PI * radius;
//   const pct = value == null ? 0 : Math.max(0, Math.min(100, value));
//   const offset = circumference - (pct / 100) * circumference;
//   const color = value == null ? "#d0d0d0" : value >= 75 ? "#1e7e34" : value >= 50 ? "#c9891a" : "#b3261e";

//   return (
//     <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
//       <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
//         <circle cx={size / 2} cy={size / 2} r={radius} stroke="#eef0f2" strokeWidth={stroke} fill="none" />
//         <circle
//           cx={size / 2}
//           cy={size / 2}
//           r={radius}
//           stroke={color}
//           strokeWidth={stroke}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={offset}
//           strokeLinecap="round"
//           style={{ transition: "stroke-dashoffset 0.3s ease" }}
//         />
//       </svg>
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <span style={{ fontSize: `${size * 0.22}px`, fontWeight: "bold", color: value == null ? "#8a8a8a" : "#1a1a1a", lineHeight: 1 }}>
//           {value == null ? "-" : value}
//         </span>
//         <span style={{ fontSize: `${size * 0.11}px`, color: "#8a8a8a" }}>/100</span>
//       </div>
//     </div>
//   );
// }

// // One card combining a circular score gauge (left) with its factor
// // breakdown (right, filling the remaining width).
// function AtsScoreBreakdownCard({ title, score, breakdown, note, reasoning, gaugeSize = 84 }) {
//   const entries = Object.entries(breakdown || {}).filter(([factor]) => factor !== "reasoning");
//   return (
//     <div style={CARD_STYLE}>
//       <CardTitle>{title}</CardTitle>
//       <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
//         <CircularScore value={score} size={gaugeSize} />
//         <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
//           {note}
//           {entries.map(([factor, value]) => (
//             <div key={factor}>
//               <div style={{ fontSize: "11px", color: "#5a5a5a", marginBottom: "3px" }}>{FACTOR_LABELS[factor] || factor}</div>
//               <ScoreBar value={value} />
//             </div>
//           ))}
//         </div>
//       </div>
//       <ScoreReasoning breakdown={reasoning} />
//     </div>
//   );
// }

// function StatusBadge({ status }) {
//   const colors = STATUS_COLORS[status] || STATUS_COLORS.PENDING;
//   return (
//     <span
//       style={{
//         backgroundColor: colors.bg,
//         color: colors.fg,
//         padding: "3px 10px",
//         borderRadius: "3px",
//         fontSize: "12px",
//         fontWeight: "bold",
//       }}
//     >
//       {status.replace("_", " ")}
//     </span>
//   );
// }

// const SKILL_STATUS_COLORS = {
//   PRESENT: "#1e7e34",
//   PARTIAL: "#8a6d00",
//   SKILLS_ONLY_MATCH: "#b56a1f",
//   MISSING: "#5a5a5a",
//   DO_NOT_ADD: "#b3261e",
// };

// const SKILL_STATUS_BG = {
//   PRESENT: "#e6f4ea",
//   PARTIAL: "#fff8e1",
//   SKILLS_ONLY_MATCH: "#fdf1e6",
//   MISSING: "#f4f5f7",
//   DO_NOT_ADD: "#fdecea",
// };

// const RULE_STATUS_STYLES = {
//   PASS: { bg: "#e6f4ea", fg: "#1e7e34", label: "PASS" },
//   FAIL: { bg: "#fdecea", fg: "#b3261e", label: "FAIL" },
//   PENDING: { bg: "#f4f5f7", fg: "#5a5a5a", label: "PENDING" },
//   NOT_AUTOMATED: { bg: "#fff8e1", fg: "#8a6d00", label: "NOT AUTOMATED" },
//   NOT_REQUIRED: { bg: "#f4f5f7", fg: "#5a5a5a", label: "NOT REQUIRED" },
// };

// function CandidateDetailsCard({ opt, jd }) {
//   return (
//     <div style={CARD_STYLE}>
//       <CardTitle>Candidate Details</CardTitle>
//       <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//         <InfoField label="Candidate" value={`${opt.candidateId?.name} (${opt.candidateId?.email})`} />
//         <InfoField label="Client" value={`${opt.clientId?.name || "-"}${opt.clientId?.industry ? ` (${opt.clientId.industry})` : ""}`} />
//         <InfoField label="Job Title" value={jd.title || "-"} />
//         <InfoField label="JD URL" value={jd.url ? <a href={jd.url} target="_blank" rel="noreferrer">{jd.url}</a> : "-"} />
//         <InfoField label="Required Experience" value={jd.requiredExperience != null ? `${jd.requiredExperience}+ years` : "Not specified"} />
//         <InfoField label="Overall Status" value={<StatusBadge status={opt.status} />} />
//       </div>
//     </div>
//   );
// }

// function EligibilityCard({ opt }) {
//   const rows = buildEligibilityChecklist(opt);
//   return (
//     <div style={CARD_STYLE}>
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
//         <CardTitle>Eligibility (Rule Engine)</CardTitle>
//         <StatusBadge status={opt.eligibility?.status || "PENDING"} />
//       </div>
//       <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//         {rows.map((row, i) => {
//           const style = RULE_STATUS_STYLES[row.status] || RULE_STATUS_STYLES.PENDING;
//           return (
//             <div key={row.criterion} style={{ borderTop: i === 0 ? "none" : "1px solid #eee", paddingTop: i === 0 ? 0 : "8px" }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
//                 <span style={{ fontSize: "12.5px", fontWeight: "bold" }}>{row.criterion}</span>
//                 <span
//                   style={{
//                     backgroundColor: style.bg,
//                     color: style.fg,
//                     padding: "2px 8px",
//                     borderRadius: "3px",
//                     fontSize: "10.5px",
//                     fontWeight: "bold",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {style.label}
//                 </span>
//               </div>
//               <div style={{ fontSize: "11.5px", color: "#5a5a5a", marginTop: "2px" }}>{row.detail}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// // Top-summary Initial ATS card.
// function InitialAtsCard({ opt }) {
//   if (opt.status === "DISQUALIFIED" || opt.ats?.initialScore == null) {
//     return (
//       <div style={CARD_STYLE}>
//         <CardTitle>Initial ATS Score</CardTitle>
//         <p style={{ color: "#5a5a5a", fontSize: "13px", margin: 0 }}>
//           {opt.status === "DISQUALIFIED"
//             ? "Not scored — candidate does not meet a mandatory requirement."
//             : "Not scored yet."}
//         </p>
//       </div>
//     );
//   }

//   const note =
//     opt.ats.confidence != null && opt.ats.confidence < 1 ? (
//       <p style={{ color: "#8a6d00", fontSize: "12px", margin: 0 }}>
//         Based on {Math.round(opt.ats.confidence * 100)}% of scoring factors — the rest (
//         {(opt.ats.unmeasuredFactors || []).map((f) => FACTOR_LABELS[f] || f).join(", ")}) aren't measurable yet.
//       </p>
//     ) : null;

//   return (
//     <AtsScoreBreakdownCard
//       title="Initial ATS Score"
//       score={opt.ats.initialScore}
//       breakdown={opt.ats.initialBreakdown}
//       note={note}
//       reasoning={opt.ats.initialBreakdown}
//     />
//   );
// }

// function SkillTable({ skills, skillType, onToggle, optimizationId }) {
//   // Name of the skill whose override popup is open (null = closed).
//   const [overridingSkill, setOverridingSkill] = useState(null);

//   if (!skills || skills.length === 0) {
//     return <p style={{ color: "#5a5a5a", fontSize: "14px" }}>No {skillType} skills were specified for this role.</p>;
//   }

//   const skillBeingOverridden = skills.find((s) => s.name === overridingSkill) || null;

//   // approvedBullet: the exact AI bullet the recruiter accepted with
//   // "Use this bullet" in the popup, or null if they wrote their own text.
//   const handleApprove = (justification, targetCompany, approvedBullet) => {
//     onToggle(skillType, overridingSkill, true, justification, targetCompany, approvedBullet || null);
//     setOverridingSkill(null);
//   };

//   return (
//     <>
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
//           gap: "14px",
//           alignItems: "stretch",
//         }}
//       >
//         {skills.map((s, i) => {
//           const isOverridable = ["MISSING", "SKILLS_ONLY_MATCH"].includes(s.status);
//           const isBlockedAndUnselected = (s.status === "DO_NOT_ADD" || isOverridable) && !s.selected;

//           return (
//             <div
//               key={i}
//               style={{
//                 border: "1px solid #e0e0e0",
//                 borderRadius: "6px",
//                 padding: "12px 14px",
//                 backgroundColor: "#fff",
//                 boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
//                 display: "flex",
//                 flexDirection: "column",
//                 height: "100%",
//               }}
//             >
//               <div style={{ flex: "1 1 auto" }}>
//                 <div style={{ fontWeight: "bold", fontSize: "14px", lineHeight: "1.35", marginBottom: "8px" }}>
//                   {s.name}
//                 </div>

//                 <div style={{ marginBottom: "8px" }}>
//                   <span
//                     style={{
//                       backgroundColor: SKILL_STATUS_BG[s.status] || "#f4f5f7",
//                       color: SKILL_STATUS_COLORS[s.status] || "#5a5a5a",
//                       padding: "3px 10px",
//                       borderRadius: "3px",
//                       fontSize: "11px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {s.status.replace(/_/g, " ")}
//                   </span>
//                 </div>

//                 {s.reason && (
//                   <div style={{ fontSize: "12px", color: "#5a5a5a", marginBottom: "6px" }}>{s.reason}</div>
//                 )}

//                 {s.override?.justification && findDraftLanguage(s.override.justification).length > 0 && (
//                   <div
//                     style={{
//                       fontSize: "12px",
//                       color: "#b3261e",
//                       backgroundColor: "#fdecea",
//                       borderRadius: "3px",
//                       padding: "4px 8px",
//                       marginBottom: "6px",
//                     }}
//                   >
//                     <strong>Needs editing:</strong> this justification is still an unconfirmed AI draft (
//                     {findDraftLanguage(s.override.justification).join(", ")}). Untick "Use in optimized resume" and override
//                     again with what the candidate confirmed — resume generation is blocked until then.
//                   </div>
//                 )}

//                 {s.override?.justification && (
//                   <div style={{ fontSize: "12px", color: "#1a4d8f", marginBottom: "6px" }}>
//                     <strong>Recruiter override:</strong> {s.override.justification}
//                     {s.override.targetCompany && (
//                       <div style={{ marginTop: "3px" }}>
//                         <strong>Added to role at:</strong> {s.override.targetCompany}
//                       </div>
//                     )}
//                   </div>
//                 )}

//                 {/* Exact bullet that will be added to the role as written */}
//                 {s.override?.approvedBullet && (
//                   <div
//                     style={{
//                       fontSize: "12px",
//                       color: "#1a1a1a",
//                       backgroundColor: "#f4f8fc",
//                       borderLeft: "3px solid #1a4d8f",
//                       borderRadius: "3px",
//                       padding: "6px 8px",
//                       marginBottom: "6px",
//                     }}
//                   >
//                     <strong style={{ color: "#1a4d8f" }}>Bullet added to resume:</strong> {s.override.approvedBullet}
//                   </div>
//                 )}

//                 {isOverridable && !s.selected && (
//                   <div style={{ marginBottom: "4px" }}>
//                     <button
//                       type="button"
//                       onClick={() => setOverridingSkill(s.name)}
//                       style={{ fontSize: "12px", background: "none", border: "none", color: "#1a4d8f", textDecoration: "underline", cursor: "pointer", padding: 0 }}
//                     >
//                       Override (needs justification)
//                     </button>
//                   </div>
//                 )}
//               </div>

//               <label
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   gap: "8px",
//                   fontSize: "12px",
//                   color: "#5a5a5a",
//                   marginTop: "10px",
//                   paddingTop: "10px",
//                   borderTop: "1px solid #eee",
//                   cursor: (s.status === "DO_NOT_ADD" || isBlockedAndUnselected) ? "default" : "pointer",
//                 }}
//               >
//                 Use in optimized resume
//                 <input
//                   type="checkbox"
//                   checked={!!s.selected}
//                   disabled={s.status === "DO_NOT_ADD" || isBlockedAndUnselected}
//                   onChange={(e) => onToggle(skillType, s.name, e.target.checked)}
//                 />
//               </label>
//             </div>
//           );
//         })}
//       </div>

//       {skillBeingOverridden && (
//         <SkillOverrideModal
//           key={skillBeingOverridden.name}
//           skill={skillBeingOverridden}
//           skillType={skillType}
//           optimizationId={optimizationId}
//           onApprove={handleApprove}
//           onClose={() => setOverridingSkill(null)}
//         />
//       )}
//     </>
//   );
// }
// export default function OptimizationDetail() {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const { selectedOptimization, status, error } = useSelector((state) => state.optimizations);
//   const loading = status === "loading";

//   const [runningStep, setRunningStep] = useState(null);
//   const [requestedChangesText, setRequestedChangesText] = useState("");
//   const [ruleStatus, setRuleStatus] = useState(null);
//   const [checkingRules, setCheckingRules] = useState(false);
//   const [activeSection, setActiveSection] = useState(0);

//   useEffect(() => {
//     dispatch(fetchOptimizationById(id));
//     return () => {
//       dispatch(clearSelectedOptimization());
//       dispatch(clearOptimizationError());
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id]);

//   const handleDecision = (decision) => {
//     dispatch(resolveEligibility({ id, decision }));
//   };

//   const runStep = async (stepName, thunkPromise) => {
//     setRunningStep(stepName);
//     try {
//       await thunkPromise;
//     } finally {
//       setRunningStep(null);
//     }
//   };

//   // Recovery-only parse: shown only when the JD was never parsed (the
//   // automatic parse at creation failed, or the optimization predates
//   // auto-parsing). Fills blank fields only.
//   const handleParseJd = () => runStep("parseJd", dispatch(parseJd({ id, overwrite: false })));
//   const handleMatchSkills = () => runStep("matchSkills", dispatch(matchSkills(id)));
//   const handleTitleAlignment = () => runStep("titleAlignment", dispatch(generateTitleAlignment(id)));
//   const handleGenerateSummary = () =>
//     runStep(
//       "summary",
//       dispatch(
//         generateSummary({
//           id,
//           currentSummary: selectedOptimization?.summary?.current || "",
//           requestedChanges: requestedChangesText,
//         })
//       )
//     );
//   const handleGenerateExperience = () => runStep("experience", dispatch(generateExperience(id)));
//   const handleGenerateFinalResume = () => runStep("finalResume", dispatch(generateFinalResume(id)));

//   const handleCheckRuleStatus = async () => {
//     setCheckingRules(true);
//     try {
//       const result = await dispatch(fetchRuleStatus(id));
//       if (fetchRuleStatus.fulfilled.match(result)) {
//         setRuleStatus(result.payload);
//       } else {
//         alert(`Could not check rule status: ${result.payload || "Unknown error."}`);
//       }
//     } finally {
//       setCheckingRules(false);
//     }
//   };

//   const handleToggleSkill = (skillType, name, selected, overrideJustification, overrideTargetCompany, overrideApprovedBullet) => {
//     dispatch(
//       updateSkillSelection({
//         id,
//         skillType,
//         name,
//         selected,
//         overrideJustification,
//         overrideTargetCompany,
//         overrideApprovedBullet,
//       })
//     );
//   };

//   const handleDownloadFinalResume = async (versionId, fileName) => {
//     const candidateId = selectedOptimization?.candidateId?._id || selectedOptimization?.candidateId?.id;
//     try {
//       const res = await api.get(`/candidate/${candidateId}/resume-versions/${versionId}/download`, {
//         responseType: "blob",
//       });
//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName || "final-resume.docx");
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch {
//       alert("Could not download the final resume.");
//     }
//   };

//   if (loading && !selectedOptimization) {
//     return (
//       <div className="page-container">
//         <p>Loading optimization...</p>
//       </div>
//     );
//   }

//   if (!selectedOptimization) {
//     return (
//       <div className="page-container">
//         {error && <div className="auth-error">{error}</div>}
//         <Link to="/dashboard/optimizations">Back to optimizations</Link>
//       </div>
//     );
//   }

//   const opt = selectedOptimization;
//   const jd = opt.jobDescription || {};

//   // The seven browsable sections, built here (inside the component) since
//   // each one's content closes over `opt`, handlers, and local state.
//   // Rendering order matches what the slider cycles through.
//   const sections = [
//     {
//       key: "required-skills",
//       title: "Required Skills",
//       action: (
//         <button type="button" onClick={handleMatchSkills} disabled={runningStep === "matchSkills"} style={SECTION_ACTION_BUTTON_STYLE}>
//           {runningStep === "matchSkills" ? "Matching Skills..." : "Match Skills with AI"}
//         </button>
//       ),
//       content: <SkillTable skills={opt.requiredSkills} skillType="required" onToggle={handleToggleSkill} optimizationId={id} />,
//     },
//     {
//       key: "preferred-skills",
//       title: "Preferred Skills",
//       content: (
//         <>
//           <SkillTable skills={opt.preferredSkills} skillType="preferred" onToggle={handleToggleSkill} optimizationId={id} />
//           <p style={{ color: "#5a5a5a", fontSize: "13px", marginTop: "16px", marginBottom: 0 }}>
//             Keyword Match, Industry Fit, and Qualifications are interim estimates until that part of Stage 4 is
//             connected — Required Skills, Preferred Skills, and Experience Match are fully accurate today, and Title
//             Alignment is AI-generated once you run it.
//           </p>
//         </>
//       ),
//     },
//     {
//       key: "title-alignment",
//       title: "Title Alignment",
//       action: (
//         <button type="button" onClick={handleTitleAlignment} disabled={runningStep === "titleAlignment"} style={SECTION_ACTION_BUTTON_STYLE}>
//           {runningStep === "titleAlignment" ? "Generating..." : "Generate Suggested Title"}
//         </button>
//       ),
//       content: opt.titleAlignment?.suggestedTitle ? (
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "14px 20px" }}>
//           <InfoField label="Current Title" value={opt.titleAlignment.currentTitle || "-"} />
//           <InfoField label="Required Title" value={opt.titleAlignment.requiredTitle || "-"} />
//           <InfoField label="Suggested Title" value={<strong>{opt.titleAlignment.suggestedTitle}</strong>} />
//           {opt.titleAlignment.rationale && (
//             <div style={{ gridColumn: "1 / -1" }}>
//               <InfoField label="Why" value={<span style={{ fontSize: "13px", color: "#5a5a5a" }}>{opt.titleAlignment.rationale}</span>} />
//             </div>
//           )}
//         </div>
//       ) : (
//         <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not generated yet.</p>
//       ),
//     },
//     {
//       key: "professional-summary",
//       title: "Professional Summary",
//       content: (
//         <>
//           <label htmlFor="summary-guidance" style={{ display: "block", fontSize: "13px", fontWeight: "bold", marginBottom: "2px" }}>
//             Additional guidance <span style={{ fontWeight: "normal", color: "#5a5a5a" }}>(optional)</span>
//           </label>
//           <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 6px" }}>
//             Describe anything you want emphasized or changed, then generate — comma or newline separated.
//           </p>
//           <textarea
//             id="summary-guidance"
//             className="form-textarea"
//             rows={3}
//             style={{ marginBottom: "10px" }}
//             placeholder="e.g. emphasize cloud migration experience, keep it under 4 sentences"
//             value={requestedChangesText}
//             onChange={(e) => setRequestedChangesText(e.target.value)}
//           />
//           <div>
//             <button type="button" onClick={handleGenerateSummary} disabled={runningStep === "summary"}>
//               {runningStep === "summary" ? "Generating..." : "Generate Optimized Summary"}
//             </button>
//           </div>
//           {opt.summary?.optimized && (
//             <div style={{ ...CARD_STYLE, marginTop: "14px" }}>
//               <CardTitle>Optimized Summary</CardTitle>
//               <p style={{ margin: 0, fontSize: "14px", lineHeight: "1.6" }}>{opt.summary.optimized}</p>
//             </div>
//           )}
//         </>
//       ),
//     },
//     {
//       key: "experience",
//       title: "Experience",
//       action: (
//         <button type="button" onClick={handleGenerateExperience} disabled={runningStep === "experience"} style={SECTION_ACTION_BUTTON_STYLE}>
//           {runningStep === "experience" ? "Rewriting..." : "Rewrite Experience with AI"}
//         </button>
//       ),
//       content: (
//         <>
//           <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 12px" }}>
//             Only skills checked "Use in Optimized Resume" above are woven into these rewrites. Requires the
//             candidate's master resume to have been AI-parsed first (Candidate detail page → Resume History → "Parse
//             with AI").
//           </p>
//           <AiChangesLegend />
//           {(opt.experience || []).length === 0 ? (
//             <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not generated yet.</p>
//           ) : (
//             opt.experience.map((role, i) => (
//               <div key={i} style={{ marginBottom: i === opt.experience.length - 1 ? 0 : "24px" }}>
//                 <strong style={{ fontSize: "14px" }}>
//                   {role.title || "Role"} — {role.companyName} ({role.employmentDates})
//                 </strong>
//                 <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "14px", marginTop: "10px", alignItems: "stretch" }}>
//                   <div style={{ border: "1px solid #e0e0e0", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
//                     <div style={{ fontSize: "11px", fontWeight: "bold", color: "#5a5a5a", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "8px" }}>
//                       Original
//                     </div>
//                     <ul style={{ fontSize: "13px", margin: 0, paddingLeft: "18px" }}>
//                       {(role.originalBullets || []).map((b, bi) => (
//                         <li key={bi} style={{ marginBottom: "6px" }}>{b}</li>
//                       ))}
//                     </ul>
//                   </div>
//                   <div style={{ border: "1px solid #d7ead9", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
//                     <div style={{ fontSize: "11px", fontWeight: "bold", color: "#1e7e34", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "8px" }}>
//                       Optimized
//                     </div>
//                     <HighlightedBulletList
//                       originalBullets={role.originalBullets || []}
//                       optimizedBullets={role.optimizedBullets || []}
//                     />
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </>
//       ),
//     },
//     {
//       // Project Sync (LLM Op #6c) — reviewable before the final resume.
//       // ProjectsSection has its own Generate/Regenerate button and reloads
//       // the optimization afterwards so the saved projects show here.
//       key: "projects",
//       title: "Projects",
//       content: (
//         <ProjectsSection
//           opt={opt}
//           optimizationId={id}
//           onGenerated={() => dispatch(fetchOptimizationById(id))}
//         />
//       ),
//     },
//     {
//       key: "rule-engine-status",
//       title: "Rule Engine Status",
//       action: (
//         <button type="button" onClick={handleCheckRuleStatus} disabled={checkingRules} style={SECTION_ACTION_BUTTON_STYLE}>
//           {checkingRules ? "Checking..." : "Check Rule Status"}
//         </button>
//       ),
//       content: (
//         <>
//           <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 12px" }}>
//             Deterministic checks, not AI — the same checks that gate Final Resume generation below, run here
//             read-only so you can see compliance status anytime. PENDING means a prerequisite step hasn't been run
//             yet; NOT AUTOMATED means that rule isn't machine-checkable (reviewed manually instead).
//           </p>
//           {ruleStatus ? (
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "14px" }}>
//               {ruleStatus.map((r) => {
//                 const style = RULE_STATUS_STYLES[r.status] || RULE_STATUS_STYLES.PENDING;
//                 return (
//                   <div key={r.rule} style={{ border: "1px solid #e0e0e0", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
//                       <span style={{ fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>{r.rule}</span>
//                       <span
//                         style={{
//                           backgroundColor: style.bg,
//                           color: style.fg,
//                           padding: "3px 10px",
//                           borderRadius: "3px",
//                           fontSize: "11px",
//                           fontWeight: "bold",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {style.label}
//                       </span>
//                     </div>
//                     <div style={{ fontSize: "13px", fontWeight: "600", marginBottom: "4px" }}>{r.label}</div>
//                     <div style={{ fontSize: "12px", color: "#5a5a5a" }}>{r.message}</div>
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not checked yet.</p>
//           )}
//         </>
//       ),
//     },
//   ];

//   const activeSectionData = sections[activeSection];

//   return (
//     <div className="page-container">
//       <div className="page-header">
//         <h2>{opt.candidateId?.name} → {jd.title || "Untitled Role"}</h2>
//         <Link to="/dashboard/optimizations">Back to optimizations</Link>
//       </div>

//       {error && <div className="auth-error">{error}</div>}

//       {jd.aiParsedAt ? (
//         // Normal case: the JD was parsed (by the preview on Start
//         // Optimization, or automatically at creation) — just show status.
//         <div style={{ margin: "8px 0 20px", fontSize: "13px", color: "#5a5a5a" }}>
//           <span style={{ color: "#2f7a3d", fontWeight: "bold" }}>✓ Job description parsed by AI</span>
//           {" "}on {formatDateTime(jd.aiParsedAt)}
//         </div>
//       ) : (
//         // Recovery: never parsed — the automatic parse at creation failed,
//         // or this optimization was created before auto-parsing existed.
//         <div
//           style={{
//             margin: "8px 0 20px",
//             padding: "14px 16px",
//             backgroundColor: "#fff8e1",
//             borderRadius: "4px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "20px",
//           }}
//         >
//           <div>
//             <strong style={{ fontSize: "14px" }}>Job description not parsed by AI yet</strong>
//             <p style={{ fontSize: "13px", color: "#5a5a5a", margin: "4px 0 0" }}>
//               The automatic parse didn't run for this optimization (it may have failed, or the optimization
//               was created before auto-parsing). Parsing extracts the title, required/preferred skills, required
//               experience, preferred background and eligibility requirements — it only fills in fields that are
//               still blank.
//             </p>
//           </div>
//           <button type="button" onClick={handleParseJd} disabled={runningStep === "parseJd"} style={{ flexShrink: 0 }}>
//             {runningStep === "parseJd" ? "Parsing JD..." : "Parse Job Description with AI"}
//           </button>
//         </div>
//       )}

//       {/* Candidate Details / Eligibility / Initial ATS Score — one row */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//           gap: "16px",
//           alignItems: "stretch",
//         }}
//       >
//         <CandidateDetailsCard opt={opt} jd={jd} />
//         <EligibilityCard opt={opt} />
//         <InitialAtsCard opt={opt} />
//       </div>

//       {opt.jobDescription?.preferredBackground?.length > 0 && (
//         <div style={{ marginTop: "16px", padding: "10px 12px", backgroundColor: "#f4f5f7", borderRadius: "4px" }}>
//           <div style={{ fontSize: "12px", fontWeight: "bold", color: "#5a5a5a", marginBottom: "4px" }}>
//             Preferred background per JD (informational — not a checkable skill, factored into Domain Fit above, not scored as a Skill)
//           </div>
//           <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", color: "#3a3a3a" }}>
//             {opt.jobDescription.preferredBackground.map((line, i) => (
//               <li key={i}>{line}</li>
//             ))}
//           </ul>
//         </div>
//       )}

//       {opt.eligibility?.status === "NEEDS_REVIEW" && (
//         <div style={{ marginTop: "16px", padding: "12px", backgroundColor: "#fff8e1", borderRadius: "4px" }}>
//           <p style={{ marginTop: 0, fontSize: "14px" }}>
//             This role has requirements the system can't verify automatically. Review the reasons above, then confirm
//             how to proceed — optimization work only continues once you decide.
//           </p>
//           <button type="button" onClick={() => handleDecision("ELIGIBLE")} disabled={loading}>
//             Confirm Eligible
//           </button>{" "}
//           <button type="button" className="btn-secondary" onClick={() => handleDecision("DISQUALIFIED")} disabled={loading}>
//             Mark Disqualified
//           </button>
//         </div>
//       )}

//       {opt.status === "DISQUALIFIED" && (
//         <div style={{ marginTop: "16px", padding: "12px", backgroundColor: "#fdecea", borderRadius: "4px", color: "#b3261e" }}>
//           <strong>Do Not Apply</strong> — this candidate does not meet a mandatory requirement for this role. No ATS
//           scoring or resume optimization was performed.
//         </div>
//       )}

//       {opt.status !== "DISQUALIFIED" && opt.ats?.initialScore != null && (
//         <>
//           <SectionSlider sections={sections} activeIndex={activeSection} onSelect={setActiveSection} />

//           <div style={{ border: "1px solid #e0e0e0", borderRadius: "10px", backgroundColor: "#fff", marginTop: "12px", overflow: "hidden" }}>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 padding: "16px",
//                 backgroundColor: "#f7f9fb",
//                 borderBottom: "1px solid #e0e0e0",
//                 flexWrap: "wrap",
//                 gap: "10px",
//               }}
//             >
//               <h3 style={{ margin: 0, fontSize: "16px", color: "#1a4d8f" }}>{activeSectionData.title}</h3>
//               {activeSectionData.action}
//             </div>
//             <div style={{ padding: "16px" }}>{activeSectionData.content}</div>
//           </div>

//           {/* Step 15: Final Resume + Final ATS Score */}
//           <div className="page-header" style={{ marginTop: "28px" }}>
//             <h3>Final Resume &amp; ATS Validation</h3>
//             <button type="button" onClick={handleGenerateFinalResume} disabled={runningStep === "finalResume"}>
//               {runningStep === "finalResume" ? "Generating..." : "Generate Final Resume"}
//             </button>
//           </div>
//           <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 8px" }}>
//             Runs the same rule check above before generating anything — if a rule is violated, you'll see exactly
//             which one and why instead of a file being produced. Requires the Summary and Experience steps above to
//             be generated first.
//           </p>

//           {opt.status === "COMPLETED" && opt.ats?.finalScore != null ? (
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//                 gap: "16px",
//                 alignItems: "stretch",
//               }}
//             >
//               <AtsScoreBreakdownCard
//                 title="Initial ATS Score"
//                 score={opt.ats.initialScore}
//                 breakdown={opt.ats.initialBreakdown}
//                 reasoning={opt.ats.initialBreakdown}
//               />
//               <AtsScoreBreakdownCard
//                 title="Final ATS Score"
//                 score={opt.ats.finalScore}
//                 breakdown={opt.ats.breakdown}
//                 reasoning={opt.ats.breakdown}
//               />
//               <div style={{ ...CARD_STYLE, display: "flex", flexDirection: "column" }}>
//                 <CardTitle>Improvement</CardTitle>
//                 <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                   {opt.ats.initialScore != null ? (
//                     (() => {
//                       const delta = opt.ats.finalScore - opt.ats.initialScore;
//                       const color = delta > 0 ? "#1e7e34" : delta < 0 ? "#b3261e" : "#5a5a5a";
//                       return (
//                         <span style={{ color, fontWeight: "bold", fontSize: "24px" }}>
//                           {delta > 0 ? "+" : ""}
//                           {delta} points
//                         </span>
//                       );
//                     })()
//                   ) : (
//                     <span style={{ fontSize: "14px", color: "#5a5a5a" }}>-</span>
//                   )}
//                 </div>
//                 {opt.finalResumeVersion && (
//                   <button
//                     type="button"
//                     style={{ marginTop: "12px" }}
//                     onClick={() => handleDownloadFinalResume(opt.finalResumeVersion.id || opt.finalResumeVersion._id, opt.finalResumeVersion.fileName)}
//                   >
//                     Download Final Resume (.docx)
//                   </button>
//                 )}
//               </div>
//             </div>
//           ) : (
//             <p style={{ color: "#5a5a5a", fontSize: "14px" }}>Not generated yet.</p>
//           )}

//           {/* What the last generation couldn't do in the file — previously
//               produced by the backend but never shown anywhere. */}
//           {opt.finalResumeWarnings?.length > 0 && (
//             <div
//               style={{
//                 marginTop: "16px",
//                 padding: "12px 14px",
//                 backgroundColor: "#fff8e1",
//                 border: "1px solid #f0dca0",
//                 borderRadius: "4px",
//                 fontSize: "13px",
//               }}
//             >
//               <strong>Check the downloaded resume — notes from the last generation:</strong>
//               <ul style={{ margin: "6px 0 0", paddingLeft: "20px" }}>
//                 {opt.finalResumeWarnings.map((w, wi) => (
//                   <li key={wi} style={{ marginBottom: "3px" }}>
//                     {w}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </>
//       )}

//       {/* AI Screening — generate a voice screening test from this JD + master resume */}
//       <ScreeningPanel optimization={opt} />
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../api/axiosInstance";
import SkillOverrideModal from "../components/SkillOverrideModal";
import {
  fetchOptimizationById,
  resolveEligibility,
  updateSkillSelection,
  parseJd,
  matchSkills,
  generateTitleAlignment,
  generateSummary,
  generateExperience,
  generateFinalResume,
  fetchRuleStatus,
  clearOptimizationError,
  clearSelectedOptimization,
} from "../slice/optimizationSlice";
import { formatDateTime } from "../utils/formatters";
import { findDraftLanguage } from "../utils/overrideDraftCheck";
import ProjectsSection from "../components/ProjectsSection";
import HighlightedBulletList, { AiChangesLegend } from "../components/HighlightedBulletList";
import ScreeningPanel from "../components/ScreeningPanel";
import FinalResumeJdCard from "../components/FinalResumeJdCard";

const STATUS_COLORS = {
  ELIGIBLE: { bg: "#e6f4ea", fg: "#1e7e34" },
  NEEDS_REVIEW: { bg: "#fff8e1", fg: "#8a6d00" },
  DISQUALIFIED: { bg: "#fdecea", fg: "#b3261e" },
  PENDING: { bg: "#f4f5f7", fg: "#5a5a5a" },
};

const FACTOR_LABELS = {
  skillsMatch: "Skills Match",
  experienceMatch: "Experience Match",
  titleAlignment: "Title Alignment",
  industryFit: "Industry Fit",
  resumeQuality: "Resume Quality",
};

// Shared card shell used across the summary row, rule engine grid, and
// final ATS comparison row.
const CARD_STYLE = {
  border: "1px solid #e0e0e0",
  borderRadius: "6px",
  padding: "14px 16px",
  backgroundColor: "#fff",
  height: "100%",
  boxSizing: "border-box",
};

// Fixed-size button style for the section panel's header action.
const SECTION_ACTION_BUTTON_STYLE = { padding: "6px 14px", fontSize: "13px", minWidth: "190px", textAlign: "center" };

// One tile in the section slider. `role` is "center" (the active
// section, shown larger/prominent) or "side" (a neighboring section,
// shown smaller and faded — a "peek" the user can click to jump to it).
function SliderTile({ title, role, onClick }) {
  const isCenter = role === "center";
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
      style={{
        cursor: "pointer",
        flex: isCenter ? "0 0 300px" : "0 0 200px",
        padding: isCenter ? "20px 22px" : "16px 18px",
        borderRadius: "12px",
        border: isCenter ? "2px solid #1a4d8f" : "1px solid #e0e0e0",
        backgroundColor: "#fff",
        boxShadow: isCenter ? "0 6px 18px rgba(0,0,0,0.10)" : "0 1px 3px rgba(0,0,0,0.05)",
        opacity: isCenter ? 1 : 0.65,
        transform: isCenter ? "scale(1)" : "scale(0.9)",
        transition: "all 0.2s ease",
        textAlign: "center",
        userSelect: "none",
      }}
    >
      <div style={{ fontSize: isCenter ? "16px" : "13.5px", fontWeight: 600, color: isCenter ? "#1a4d8f" : "#5a5a5a" }}>
        {title}
      </div>
    </div>
  );
}

// Carousel strip: previous section (peek, left) — active section
// (center, prominent) — next section (peek, right), with left/right
// arrow buttons. Circular: past the last section wraps to the first.
function SectionSlider({ sections, activeIndex, onSelect }) {
  const len = sections.length;
  const prevIndex = (activeIndex - 1 + len) % len;
  const nextIndex = (activeIndex + 1) % len;

  const arrowStyle = {
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    padding: 0,
    fontSize: "16px",
    lineHeight: 1,
    flexShrink: 0,
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", padding: "50px 0", flexWrap: "wrap" }}>
      <button type="button" onClick={() => onSelect(prevIndex)} aria-label="Previous section" style={arrowStyle}>
        ‹
      </button>
      <SliderTile title={sections[prevIndex].title} role="side" onClick={() => onSelect(prevIndex)} />
      <SliderTile title={sections[activeIndex].title} role="center" onClick={() => { }} />
      <SliderTile title={sections[nextIndex].title} role="side" onClick={() => onSelect(nextIndex)} />
      <button type="button" onClick={() => onSelect(nextIndex)} aria-label="Next section" style={arrowStyle}>
        ›
      </button>
    </div>
  );
}

// A tiny reusable "why this score?" expander.
function ScoreReasoning({ breakdown }) {
  if (!breakdown?.reasoning) return null;
  return (
    <details style={{ margin: "10px 0 0", fontSize: "13px", color: "#3a3a3a" }}>
      <summary style={{ cursor: "pointer", fontWeight: "bold", color: "#1a4d8f" }}>Why this score?</summary>
      <p style={{ margin: "6px 0 0" }}>{breakdown.reasoning}</p>
    </details>
  );
}

// Compact label/value pair used inside cards below.
function InfoField({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.04em", color: "#5a5a5a", marginBottom: "3px" }}>
        {label}
      </div>
      <div style={{ fontSize: "14px", color: "#1a1a1a" }}>{value}</div>
    </div>
  );
}

// Card-header label — small caps gray, used at the top of each summary card.
function CardTitle({ children }) {
  return (
    <div style={{ fontSize: "12px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.04em", color: "#5a5a5a", marginBottom: "12px" }}>
      {children}
    </div>
  );
}

// Turns the raw eligibility inputs into a full checklist covering every
// criterion the rule engine actually looks at.
function buildEligibilityChecklist(opt) {
  const ec = opt.jobDescription?.eligibilityConstraints || {};
  const constraints = opt.eligibility?.constraints || [];
  const workAuth = opt.candidateId?.workAuthorization;

  const usCitizenViolation = constraints.find((c) => c.reason?.includes("US Citizenship is required"));
  const greenCardViolation = constraints.find((c) => c.reason?.includes("Green Card / Permanent Resident status is required"));
  const clearanceFlag = constraints.find((c) => c.rule === "RULE-EXT-CLEARANCE");
  const otherFlag = constraints.find((c) => c.rule === "RULE-EXT-OTHER");
  const domainFlag = constraints.find((c) => c.rule === "RULE-EXT-DOMAIN");

  return [
    {
      criterion: "US Citizenship Required",
      requiredLabel: ec.usCitizenshipRequired ? "Yes" : "No",
      status: !ec.usCitizenshipRequired ? "NOT_REQUIRED" : usCitizenViolation ? "FAIL" : "PASS",
      detail: !ec.usCitizenshipRequired
        ? "Not a requirement for this role."
        : usCitizenViolation
          ? usCitizenViolation.reason
          : `Candidate's work authorization (${workAuth || "on file"}) satisfies this requirement.`,
    },
    {
      criterion: "Green Card / Permanent Resident Required",
      requiredLabel: ec.greenCardRequired ? "Yes" : "No",
      status: !ec.greenCardRequired ? "NOT_REQUIRED" : greenCardViolation ? "FAIL" : "PASS",
      detail: !ec.greenCardRequired
        ? "Not a requirement for this role."
        : greenCardViolation
          ? greenCardViolation.reason
          : `Candidate's work authorization (${workAuth || "on file"}) satisfies this requirement.`,
    },
    {
      criterion: "Security / Citizenship Clearance",
      requiredLabel: ec.securityClearanceRequired ? "Yes" : "No",
      status: !ec.securityClearanceRequired ? "NOT_REQUIRED" : "NOT_AUTOMATED",
      detail: !ec.securityClearanceRequired
        ? "Not a requirement for this role."
        : clearanceFlag?.reason || "Clearance eligibility can't be verified automatically — confirm manually.",
    },
    {
      criterion: "Other Client-Specific Requirement",
      requiredLabel: ec.otherRequirement?.trim() ? ec.otherRequirement.trim() : "No",
      status: !ec.otherRequirement?.trim() ? "NOT_REQUIRED" : "NOT_AUTOMATED",
      detail: !ec.otherRequirement?.trim() ? "Not a requirement for this role." : otherFlag?.reason || "Please verify manually.",
    },
    {
      criterion: "Candidate / Job Domain Fit",
      requiredLabel: "\u2014",
      status: domainFlag ? "FAIL" : "PASS",
      detail: domainFlag ? domainFlag.reason : "Candidate's background appears to fit this role's field.",
    },
  ];
}

// A horizontal progress bar + number, used for individual factor scores.
function ScoreBar({ value, size = "normal" }) {
  const barColor = value == null ? "#e0e0e0" : value >= 75 ? "#1e7e34" : value >= 50 ? "#c9891a" : "#b3261e";
  const height = size === "large" ? 14 : 8;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div style={{ flex: 1, height: `${height}px`, backgroundColor: "#eef0f2", borderRadius: `${height / 2}px`, overflow: "hidden" }}>
        <div
          style={{
            width: `${value ?? 0}%`,
            height: "100%",
            backgroundColor: barColor,
            borderRadius: `${height / 2}px`,
            transition: "width 0.3s ease",
          }}
        />
      </div>
      <span
        style={{
          minWidth: size === "large" ? "70px" : "60px",
          textAlign: "right",
          fontSize: size === "large" ? "18px" : "13px",
          fontWeight: size === "large" ? "bold" : "normal",
          color: value == null ? "#8a8a8a" : "#1a1a1a",
          fontStyle: value == null ? "italic" : "normal",
        }}
      >
        {value == null ? "Not measured" : `${value}/100`}
      </span>
    </div>
  );
}

// Circular ring gauge for a single 0-100 overall score.
function CircularScore({ value, size = 90 }) {
  const stroke = 8;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = value == null ? 0 : Math.max(0, Math.min(100, value));
  const offset = circumference - (pct / 100) * circumference;
  const color = value == null ? "#d0d0d0" : value >= 75 ? "#1e7e34" : value >= 50 ? "#c9891a" : "#b3261e";

  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#eef0f2" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.3s ease" }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span style={{ fontSize: `${size * 0.22}px`, fontWeight: "bold", color: value == null ? "#8a8a8a" : "#1a1a1a", lineHeight: 1 }}>
          {value == null ? "-" : value}
        </span>
        <span style={{ fontSize: `${size * 0.11}px`, color: "#8a8a8a" }}>/100</span>
      </div>
    </div>
  );
}

// One card combining a circular score gauge (left) with its factor
// breakdown (right, filling the remaining width).
function AtsScoreBreakdownCard({ title, score, breakdown, note, reasoning, gaugeSize = 84 }) {
  const entries = Object.entries(breakdown || {}).filter(([factor]) => factor !== "reasoning");
  return (
    <div style={CARD_STYLE}>
      <CardTitle>{title}</CardTitle>
      <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
        <CircularScore value={score} size={gaugeSize} />
        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
          {note}
          {entries.map(([factor, value]) => (
            <div key={factor}>
              <div style={{ fontSize: "11px", color: "#5a5a5a", marginBottom: "3px" }}>{FACTOR_LABELS[factor] || factor}</div>
              <ScoreBar value={value} />
            </div>
          ))}
        </div>
      </div>
      <ScoreReasoning breakdown={reasoning} />
    </div>
  );
}

function StatusBadge({ status }) {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.PENDING;
  return (
    <span
      style={{
        backgroundColor: colors.bg,
        color: colors.fg,
        padding: "3px 10px",
        borderRadius: "3px",
        fontSize: "12px",
        fontWeight: "bold",
      }}
    >
      {status.replace("_", " ")}
    </span>
  );
}

const SKILL_STATUS_COLORS = {
  PRESENT: "#1e7e34",
  PARTIAL: "#8a6d00",
  SKILLS_ONLY_MATCH: "#b56a1f",
  MISSING: "#5a5a5a",
  DO_NOT_ADD: "#b3261e",
};

const SKILL_STATUS_BG = {
  PRESENT: "#e6f4ea",
  PARTIAL: "#fff8e1",
  SKILLS_ONLY_MATCH: "#fdf1e6",
  MISSING: "#f4f5f7",
  DO_NOT_ADD: "#fdecea",
};

const RULE_STATUS_STYLES = {
  PASS: { bg: "#e6f4ea", fg: "#1e7e34", label: "PASS" },
  FAIL: { bg: "#fdecea", fg: "#b3261e", label: "FAIL" },
  PENDING: { bg: "#f4f5f7", fg: "#5a5a5a", label: "PENDING" },
  NOT_AUTOMATED: { bg: "#fff8e1", fg: "#8a6d00", label: "NOT AUTOMATED" },
  NOT_REQUIRED: { bg: "#f4f5f7", fg: "#5a5a5a", label: "NOT REQUIRED" },
};

function CandidateDetailsCard({ opt, jd }) {
  return (
    <div style={CARD_STYLE}>
      <CardTitle>Candidate Details</CardTitle>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <InfoField label="Candidate" value={`${opt.candidateId?.name} (${opt.candidateId?.email})`} />
        <InfoField label="Client" value={`${opt.clientId?.name || "-"}${opt.clientId?.industry ? ` (${opt.clientId.industry})` : ""}`} />
        <InfoField label="Job Title" value={jd.title || "-"} />
        <InfoField label="JD URL" value={jd.url ? <a href={jd.url} target="_blank" rel="noreferrer">{jd.url}</a> : "-"} />
        <InfoField label="Required Experience" value={jd.requiredExperience != null ? `${jd.requiredExperience}+ years` : "Not specified"} />
        <InfoField label="Overall Status" value={<StatusBadge status={opt.status} />} />
      </div>
    </div>
  );
}

function EligibilityCard({ opt }) {
  const rows = buildEligibilityChecklist(opt);
  return (
    <div style={CARD_STYLE}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
        <CardTitle>Eligibility (Rule Engine)</CardTitle>
        <StatusBadge status={opt.eligibility?.status || "PENDING"} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {rows.map((row, i) => {
          const style = RULE_STATUS_STYLES[row.status] || RULE_STATUS_STYLES.PENDING;
          return (
            <div key={row.criterion} style={{ borderTop: i === 0 ? "none" : "1px solid #eee", paddingTop: i === 0 ? 0 : "8px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "12.5px", fontWeight: "bold" }}>{row.criterion}</span>
                <span
                  style={{
                    backgroundColor: style.bg,
                    color: style.fg,
                    padding: "2px 8px",
                    borderRadius: "3px",
                    fontSize: "10.5px",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                >
                  {style.label}
                </span>
              </div>
              <div style={{ fontSize: "11.5px", color: "#5a5a5a", marginTop: "2px" }}>{row.detail}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Top-summary Initial ATS card.
function InitialAtsCard({ opt }) {
  if (opt.status === "DISQUALIFIED" || opt.ats?.initialScore == null) {
    return (
      <div style={CARD_STYLE}>
        <CardTitle>Initial ATS Score</CardTitle>
        <p style={{ color: "#5a5a5a", fontSize: "13px", margin: 0 }}>
          {opt.status === "DISQUALIFIED"
            ? "Not scored — candidate does not meet a mandatory requirement."
            : "Not scored yet."}
        </p>
      </div>
    );
  }

  const note =
    opt.ats.confidence != null && opt.ats.confidence < 1 ? (
      <p style={{ color: "#8a6d00", fontSize: "12px", margin: 0 }}>
        Based on {Math.round(opt.ats.confidence * 100)}% of scoring factors — the rest (
        {(opt.ats.unmeasuredFactors || []).map((f) => FACTOR_LABELS[f] || f).join(", ")}) aren't measurable yet.
      </p>
    ) : null;

  return (
    <AtsScoreBreakdownCard
      title="Initial ATS Score"
      score={opt.ats.initialScore}
      breakdown={opt.ats.initialBreakdown}
      note={note}
      reasoning={opt.ats.initialBreakdown}
    />
  );
}

function SkillTable({ skills, skillType, onToggle, optimizationId }) {
  // Name of the skill whose override popup is open (null = closed).
  const [overridingSkill, setOverridingSkill] = useState(null);

  if (!skills || skills.length === 0) {
    return <p style={{ color: "#5a5a5a", fontSize: "14px" }}>No {skillType} skills were specified for this role.</p>;
  }

  const skillBeingOverridden = skills.find((s) => s.name === overridingSkill) || null;

  // approvedBullet: the exact AI bullet the recruiter accepted with
  // "Use this bullet" in the popup, or null if they wrote their own text.
  const handleApprove = (justification, targetCompany, approvedBullet) => {
    onToggle(skillType, overridingSkill, true, justification, targetCompany, approvedBullet || null);
    setOverridingSkill(null);
  };

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "14px",
          alignItems: "stretch",
        }}
      >
        {skills.map((s, i) => {
          const isOverridable = ["MISSING", "SKILLS_ONLY_MATCH"].includes(s.status);
          const isBlockedAndUnselected = (s.status === "DO_NOT_ADD" || isOverridable) && !s.selected;

          return (
            <div
              key={i}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                padding: "12px 14px",
                backgroundColor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <div style={{ flex: "1 1 auto" }}>
                <div style={{ fontWeight: "bold", fontSize: "14px", lineHeight: "1.35", marginBottom: "8px" }}>
                  {s.name}
                </div>

                <div style={{ marginBottom: "8px" }}>
                  <span
                    style={{
                      backgroundColor: SKILL_STATUS_BG[s.status] || "#f4f5f7",
                      color: SKILL_STATUS_COLORS[s.status] || "#5a5a5a",
                      padding: "3px 10px",
                      borderRadius: "3px",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    {s.status.replace(/_/g, " ")}
                  </span>
                </div>

                {s.reason && (
                  <div style={{ fontSize: "12px", color: "#5a5a5a", marginBottom: "6px" }}>{s.reason}</div>
                )}

                {s.override?.justification && findDraftLanguage(s.override.justification).length > 0 && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#b3261e",
                      backgroundColor: "#fdecea",
                      borderRadius: "3px",
                      padding: "4px 8px",
                      marginBottom: "6px",
                    }}
                  >
                    <strong>Needs editing:</strong> this justification is still an unconfirmed AI draft (
                    {findDraftLanguage(s.override.justification).join(", ")}). Untick "Use in optimized resume" and override
                    again with what the candidate confirmed — resume generation is blocked until then.
                  </div>
                )}

                {s.override?.justification && (
                  <div style={{ fontSize: "12px", color: "#1a4d8f", marginBottom: "6px" }}>
                    <strong>Recruiter override:</strong> {s.override.justification}
                    {s.override.targetCompany && (
                      <div style={{ marginTop: "3px" }}>
                        <strong>Added to role at:</strong> {s.override.targetCompany}
                      </div>
                    )}
                  </div>
                )}

                {/* Exact bullet that will be added to the role as written */}
                {s.override?.approvedBullet && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#1a1a1a",
                      backgroundColor: "#f4f8fc",
                      borderLeft: "3px solid #1a4d8f",
                      borderRadius: "3px",
                      padding: "6px 8px",
                      marginBottom: "6px",
                    }}
                  >
                    <strong style={{ color: "#1a4d8f" }}>Bullet added to resume:</strong> {s.override.approvedBullet}
                  </div>
                )}

                {isOverridable && !s.selected && (
                  <div style={{ marginBottom: "4px" }}>
                    <button
                      type="button"
                      onClick={() => setOverridingSkill(s.name)}
                      style={{ fontSize: "12px", background: "none", border: "none", color: "#1a4d8f", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                    >
                      Override (needs justification)
                    </button>
                  </div>
                )}
              </div>

              <label
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12px",
                  color: "#5a5a5a",
                  marginTop: "10px",
                  paddingTop: "10px",
                  borderTop: "1px solid #eee",
                  cursor: (s.status === "DO_NOT_ADD" || isBlockedAndUnselected) ? "default" : "pointer",
                }}
              >
                Use in optimized resume
                <input
                  type="checkbox"
                  checked={!!s.selected}
                  disabled={s.status === "DO_NOT_ADD" || isBlockedAndUnselected}
                  onChange={(e) => onToggle(skillType, s.name, e.target.checked)}
                />
              </label>
            </div>
          );
        })}
      </div>

      {skillBeingOverridden && (
        <SkillOverrideModal
          key={skillBeingOverridden.name}
          skill={skillBeingOverridden}
          skillType={skillType}
          optimizationId={optimizationId}
          onApprove={handleApprove}
          onClose={() => setOverridingSkill(null)}
        />
      )}
    </>
  );
}
export default function OptimizationDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { selectedOptimization, status, error } = useSelector((state) => state.optimizations);
  const loading = status === "loading";

  const [runningStep, setRunningStep] = useState(null);
  const [requestedChangesText, setRequestedChangesText] = useState("");
  const [ruleStatus, setRuleStatus] = useState(null);
  const [checkingRules, setCheckingRules] = useState(false);
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    dispatch(fetchOptimizationById(id));
    return () => {
      dispatch(clearSelectedOptimization());
      dispatch(clearOptimizationError());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleDecision = (decision) => {
    dispatch(resolveEligibility({ id, decision }));
  };

  const runStep = async (stepName, thunkPromise) => {
    setRunningStep(stepName);
    try {
      await thunkPromise;
    } finally {
      setRunningStep(null);
    }
  };

  // Recovery-only parse: shown only when the JD was never parsed (the
  // automatic parse at creation failed, or the optimization predates
  // auto-parsing). Fills blank fields only.
  const handleParseJd = () => runStep("parseJd", dispatch(parseJd({ id, overwrite: false })));
  const handleMatchSkills = () => runStep("matchSkills", dispatch(matchSkills(id)));
  const handleTitleAlignment = () => runStep("titleAlignment", dispatch(generateTitleAlignment(id)));
  const handleGenerateSummary = () =>
    runStep(
      "summary",
      dispatch(
        generateSummary({
          id,
          currentSummary: selectedOptimization?.summary?.current || "",
          requestedChanges: requestedChangesText,
        })
      )
    );
  const handleGenerateExperience = () => runStep("experience", dispatch(generateExperience(id)));
  const handleGenerateFinalResume = () => runStep("finalResume", dispatch(generateFinalResume(id)));

  const handleCheckRuleStatus = async () => {
    setCheckingRules(true);
    try {
      const result = await dispatch(fetchRuleStatus(id));
      if (fetchRuleStatus.fulfilled.match(result)) {
        setRuleStatus(result.payload);
      } else {
        alert(`Could not check rule status: ${result.payload || "Unknown error."}`);
      }
    } finally {
      setCheckingRules(false);
    }
  };

  const handleToggleSkill = (skillType, name, selected, overrideJustification, overrideTargetCompany, overrideApprovedBullet) => {
    dispatch(
      updateSkillSelection({
        id,
        skillType,
        name,
        selected,
        overrideJustification,
        overrideTargetCompany,
        overrideApprovedBullet,
      })
    );
  };

  const handleDownloadFinalResume = async (versionId, fileName) => {
    const candidateId = selectedOptimization?.candidateId?._id || selectedOptimization?.candidateId?.id;
    try {
      const res = await api.get(`/candidate/${candidateId}/resume-versions/${versionId}/download`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || "final-resume.docx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      alert("Could not download the final resume.");
    }
  };

  if (loading && !selectedOptimization) {
    return (
      <div className="page-container">
        <p>Loading optimization...</p>
      </div>
    );
  }

  if (!selectedOptimization) {
    return (
      <div className="page-container">
        {error && <div className="auth-error">{error}</div>}
        <Link to="/dashboard/optimizations">Back to optimizations</Link>
      </div>
    );
  }

  const opt = selectedOptimization;
  const jd = opt.jobDescription || {};

  // The seven browsable sections, built here (inside the component) since
  // each one's content closes over `opt`, handlers, and local state.
  // Rendering order matches what the slider cycles through.
  const sections = [
    {
      key: "required-skills",
      title: "Required Skills",
      action: (
        <button type="button" onClick={handleMatchSkills} disabled={runningStep === "matchSkills"} style={SECTION_ACTION_BUTTON_STYLE}>
          {runningStep === "matchSkills" ? "Matching Skills..." : "Match Skills with AI"}
        </button>
      ),
      content: <SkillTable skills={opt.requiredSkills} skillType="required" onToggle={handleToggleSkill} optimizationId={id} />,
    },
    {
      key: "preferred-skills",
      title: "Preferred Skills",
      content: (
        <>
          <SkillTable skills={opt.preferredSkills} skillType="preferred" onToggle={handleToggleSkill} optimizationId={id} />
          <p style={{ color: "#5a5a5a", fontSize: "13px", marginTop: "16px", marginBottom: 0 }}>
            Keyword Match, Industry Fit, and Qualifications are interim estimates until that part of Stage 4 is
            connected — Required Skills, Preferred Skills, and Experience Match are fully accurate today, and Title
            Alignment is AI-generated once you run it.
          </p>
        </>
      ),
    },
    {
      key: "title-alignment",
      title: "Title Alignment",
      action: (
        <button type="button" onClick={handleTitleAlignment} disabled={runningStep === "titleAlignment"} style={SECTION_ACTION_BUTTON_STYLE}>
          {runningStep === "titleAlignment" ? "Generating..." : "Generate Suggested Title"}
        </button>
      ),
      content: opt.titleAlignment?.suggestedTitle ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "14px 20px" }}>
          <InfoField label="Current Title" value={opt.titleAlignment.currentTitle || "-"} />
          <InfoField label="Required Title" value={opt.titleAlignment.requiredTitle || "-"} />
          <InfoField label="Suggested Title" value={<strong>{opt.titleAlignment.suggestedTitle}</strong>} />
          {opt.titleAlignment.rationale && (
            <div style={{ gridColumn: "1 / -1" }}>
              <InfoField label="Why" value={<span style={{ fontSize: "13px", color: "#5a5a5a" }}>{opt.titleAlignment.rationale}</span>} />
            </div>
          )}
        </div>
      ) : (
        <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not generated yet.</p>
      ),
    },
    {
      key: "professional-summary",
      title: "Professional Summary",
      content: (
        <>
          <label htmlFor="summary-guidance" style={{ display: "block", fontSize: "13px", fontWeight: "bold", marginBottom: "2px" }}>
            Additional guidance <span style={{ fontWeight: "normal", color: "#5a5a5a" }}>(optional)</span>
          </label>
          <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 6px" }}>
            Describe anything you want emphasized or changed, then generate — comma or newline separated.
          </p>
          <textarea
            id="summary-guidance"
            className="form-textarea"
            rows={3}
            style={{ marginBottom: "10px" }}
            placeholder="e.g. emphasize cloud migration experience, keep it under 4 sentences"
            value={requestedChangesText}
            onChange={(e) => setRequestedChangesText(e.target.value)}
          />
          <div>
            <button type="button" onClick={handleGenerateSummary} disabled={runningStep === "summary"}>
              {runningStep === "summary" ? "Generating..." : "Generate Optimized Summary"}
            </button>
          </div>
          {opt.summary?.optimized && (
            <div style={{ ...CARD_STYLE, marginTop: "14px" }}>
              <CardTitle>Optimized Summary</CardTitle>
              <p style={{ margin: 0, fontSize: "14px", lineHeight: "1.6" }}>{opt.summary.optimized}</p>
            </div>
          )}
        </>
      ),
    },
    {
      key: "experience",
      title: "Experience",
      action: (
        <button type="button" onClick={handleGenerateExperience} disabled={runningStep === "experience"} style={SECTION_ACTION_BUTTON_STYLE}>
          {runningStep === "experience" ? "Rewriting..." : "Rewrite Experience with AI"}
        </button>
      ),
      content: (
        <>
          <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 12px" }}>
            Only skills checked "Use in Optimized Resume" above are woven into these rewrites. Requires the
            candidate's master resume to have been AI-parsed first (Candidate detail page → Resume History → "Parse
            with AI").
          </p>
          <AiChangesLegend />
          {(opt.experience || []).length === 0 ? (
            <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not generated yet.</p>
          ) : (
            opt.experience.map((role, i) => (
              <div key={i} style={{ marginBottom: i === opt.experience.length - 1 ? 0 : "24px" }}>
                <strong style={{ fontSize: "14px" }}>
                  {role.title || "Role"} — {role.companyName} ({role.employmentDates})
                </strong>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "14px", marginTop: "10px", alignItems: "stretch" }}>
                  <div style={{ border: "1px solid #e0e0e0", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "11px", fontWeight: "bold", color: "#5a5a5a", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "8px" }}>
                      Original
                    </div>
                    <ul style={{ fontSize: "13px", margin: 0, paddingLeft: "18px" }}>
                      {(role.originalBullets || []).map((b, bi) => (
                        <li key={bi} style={{ marginBottom: "6px" }}>{b}</li>
                      ))}
                    </ul>
                  </div>
                  <div style={{ border: "1px solid #d7ead9", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "11px", fontWeight: "bold", color: "#1e7e34", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "8px" }}>
                      Optimized
                    </div>
                    <HighlightedBulletList
                      originalBullets={role.originalBullets || []}
                      optimizedBullets={role.optimizedBullets || []}
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </>
      ),
    },
    {
      // Project Sync (LLM Op #6c) — reviewable before the final resume.
      // ProjectsSection has its own Generate/Regenerate button and reloads
      // the optimization afterwards so the saved projects show here.
      key: "projects",
      title: "Projects",
      content: (
        <ProjectsSection
          opt={opt}
          optimizationId={id}
          onGenerated={() => dispatch(fetchOptimizationById(id))}
        />
      ),
    },
    {
      key: "rule-engine-status",
      title: "Rule Engine Status",
      action: (
        <button type="button" onClick={handleCheckRuleStatus} disabled={checkingRules} style={SECTION_ACTION_BUTTON_STYLE}>
          {checkingRules ? "Checking..." : "Check Rule Status"}
        </button>
      ),
      content: (
        <>
          <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 12px" }}>
            Deterministic checks, not AI — the same checks that gate Final Resume generation below, run here
            read-only so you can see compliance status anytime. PENDING means a prerequisite step hasn't been run
            yet; NOT AUTOMATED means that rule isn't machine-checkable (reviewed manually instead).
          </p>
          {ruleStatus ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "14px" }}>
              {ruleStatus.map((r) => {
                const style = RULE_STATUS_STYLES[r.status] || RULE_STATUS_STYLES.PENDING;
                return (
                  <div key={r.rule} style={{ border: "1px solid #e0e0e0", borderRadius: "6px", padding: "12px 14px", backgroundColor: "#fff" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                      <span style={{ fontSize: "12px", fontWeight: "bold", whiteSpace: "nowrap" }}>{r.rule}</span>
                      <span
                        style={{
                          backgroundColor: style.bg,
                          color: style.fg,
                          padding: "3px 10px",
                          borderRadius: "3px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {style.label}
                      </span>
                    </div>
                    <div style={{ fontSize: "13px", fontWeight: "600", marginBottom: "4px" }}>{r.label}</div>
                    <div style={{ fontSize: "12px", color: "#5a5a5a" }}>{r.message}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ color: "#5a5a5a", fontSize: "14px", margin: 0 }}>Not checked yet.</p>
          )}
        </>
      ),
    },
  ];

  const activeSectionData = sections[activeSection];

  return (
    <div className="page-container">
      <div className="page-header">
        <h2>{opt.candidateId?.name} → {jd.title || "Untitled Role"}</h2>
        <Link to="/dashboard/optimizations">Back to optimizations</Link>
      </div>

      {error && <div className="auth-error">{error}</div>}

      {jd.aiParsedAt ? (
        // Normal case: the JD was parsed (by the preview on Start
        // Optimization, or automatically at creation) — just show status.
        <div style={{ margin: "8px 0 20px", fontSize: "13px", color: "#5a5a5a" }}>
          <span style={{ color: "#2f7a3d", fontWeight: "bold" }}>✓ Job description parsed by AI</span>
          {" "}on {formatDateTime(jd.aiParsedAt)}
        </div>
      ) : (
        // Recovery: never parsed — the automatic parse at creation failed,
        // or this optimization was created before auto-parsing existed.
        <div
          style={{
            margin: "8px 0 20px",
            padding: "14px 16px",
            backgroundColor: "#fff8e1",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <div>
            <strong style={{ fontSize: "14px" }}>Job description not parsed by AI yet</strong>
            <p style={{ fontSize: "13px", color: "#5a5a5a", margin: "4px 0 0" }}>
              The automatic parse didn't run for this optimization (it may have failed, or the optimization
              was created before auto-parsing). Parsing extracts the title, required/preferred skills, required
              experience, preferred background and eligibility requirements — it only fills in fields that are
              still blank.
            </p>
          </div>
          <button type="button" onClick={handleParseJd} disabled={runningStep === "parseJd"} style={{ flexShrink: 0 }}>
            {runningStep === "parseJd" ? "Parsing JD..." : "Parse Job Description with AI"}
          </button>
        </div>
      )}

      {/* Candidate Details / Eligibility / Initial ATS Score — one row */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "16px",
          alignItems: "stretch",
        }}
      >
        <CandidateDetailsCard opt={opt} jd={jd} />
        <EligibilityCard opt={opt} />
        <InitialAtsCard opt={opt} />
      </div>

      {opt.jobDescription?.preferredBackground?.length > 0 && (
        <div style={{ marginTop: "16px", padding: "10px 12px", backgroundColor: "#f4f5f7", borderRadius: "4px" }}>
          <div style={{ fontSize: "12px", fontWeight: "bold", color: "#5a5a5a", marginBottom: "4px" }}>
            Preferred background per JD (informational — not a checkable skill, factored into Domain Fit above, not scored as a Skill)
          </div>
          <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", color: "#3a3a3a" }}>
            {opt.jobDescription.preferredBackground.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </div>
      )}

      {opt.eligibility?.status === "NEEDS_REVIEW" && (
        <div style={{ marginTop: "16px", padding: "12px", backgroundColor: "#fff8e1", borderRadius: "4px" }}>
          <p style={{ marginTop: 0, fontSize: "14px" }}>
            This role has requirements the system can't verify automatically. Review the reasons above, then confirm
            how to proceed — optimization work only continues once you decide.
          </p>
          <button type="button" onClick={() => handleDecision("ELIGIBLE")} disabled={loading}>
            Confirm Eligible
          </button>{" "}
          <button type="button" className="btn-secondary" onClick={() => handleDecision("DISQUALIFIED")} disabled={loading}>
            Mark Disqualified
          </button>
        </div>
      )}

      {opt.status === "DISQUALIFIED" && (
        <div style={{ marginTop: "16px", padding: "12px", backgroundColor: "#fdecea", borderRadius: "4px", color: "#b3261e" }}>
          <strong>Do Not Apply</strong> — this candidate does not meet a mandatory requirement for this role. No ATS
          scoring or resume optimization was performed.
        </div>
      )}

      {opt.status !== "DISQUALIFIED" && opt.ats?.initialScore != null && (
        <>
          <SectionSlider sections={sections} activeIndex={activeSection} onSelect={setActiveSection} />

          <div style={{ border: "1px solid #e0e0e0", borderRadius: "10px", backgroundColor: "#fff", marginTop: "12px", overflow: "hidden" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px",
                backgroundColor: "#f7f9fb",
                borderBottom: "1px solid #e0e0e0",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <h3 style={{ margin: 0, fontSize: "16px", color: "#1a4d8f" }}>{activeSectionData.title}</h3>
              {activeSectionData.action}
            </div>
            <div style={{ padding: "16px" }}>{activeSectionData.content}</div>
          </div>

          {/* Step 15: Final Resume + Final ATS Score */}
          <div className="page-header" style={{ marginTop: "28px" }}>
            <h3>Final Resume &amp; ATS Validation</h3>
            <button type="button" onClick={handleGenerateFinalResume} disabled={runningStep === "finalResume"}>
              {runningStep === "finalResume" ? "Generating..." : "Generate Final Resume"}
            </button>
          </div>
          <p style={{ color: "#5a5a5a", fontSize: "13px", margin: "0 0 8px" }}>
            Runs the same rule check above before generating anything — if a rule is violated, you'll see exactly
            which one and why instead of a file being produced. Requires the Summary and Experience steps above to
            be generated first.
          </p>

          {opt.status === "COMPLETED" && opt.ats?.finalScore != null ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                gap: "16px",
                alignItems: "stretch",
              }}
            >
              <AtsScoreBreakdownCard
                title="Initial ATS Score"
                score={opt.ats.initialScore}
                breakdown={opt.ats.initialBreakdown}
                reasoning={opt.ats.initialBreakdown}
              />
              <AtsScoreBreakdownCard
                title="Final ATS Score"
                score={opt.ats.finalScore}
                breakdown={opt.ats.breakdown}
                reasoning={opt.ats.breakdown}
              />
              <div style={{ ...CARD_STYLE, display: "flex", flexDirection: "column" }}>
                <CardTitle>Improvement</CardTitle>
                <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {opt.ats.initialScore != null ? (
                    (() => {
                      const delta = opt.ats.finalScore - opt.ats.initialScore;
                      const color = delta > 0 ? "#1e7e34" : delta < 0 ? "#b3261e" : "#5a5a5a";
                      return (
                        <span style={{ color, fontWeight: "bold", fontSize: "24px" }}>
                          {delta > 0 ? "+" : ""}
                          {delta} points
                        </span>
                      );
                    })()
                  ) : (
                    <span style={{ fontSize: "14px", color: "#5a5a5a" }}>-</span>
                  )}
                </div>
                {opt.finalResumeVersion && (
                  <button
                    type="button"
                    style={{ marginTop: "12px" }}
                    onClick={() => handleDownloadFinalResume(opt.finalResumeVersion.id || opt.finalResumeVersion._id, opt.finalResumeVersion.fileName)}
                  >
                    Download Final Resume (.docx)
                  </button>
                )}
              </div>
            </div>
          ) : (
            <p style={{ color: "#5a5a5a", fontSize: "14px" }}>Not generated yet.</p>
          )}

          {/* The JD this final resume was tailored to — shown alongside the
              generated resume so it's clear which JD produced it. */}
          {opt.status === "COMPLETED" && opt.ats?.finalScore != null && <FinalResumeJdCard opt={opt} />}

          {/* What the last generation couldn't do in the file — previously
              produced by the backend but never shown anywhere. */}
          {opt.finalResumeWarnings?.length > 0 && (
            <div
              style={{
                marginTop: "16px",
                padding: "12px 14px",
                backgroundColor: "#fff8e1",
                border: "1px solid #f0dca0",
                borderRadius: "4px",
                fontSize: "13px",
              }}
            >
              <strong>Check the downloaded resume — notes from the last generation:</strong>
              <ul style={{ margin: "6px 0 0", paddingLeft: "20px" }}>
                {opt.finalResumeWarnings.map((w, wi) => (
                  <li key={wi} style={{ marginBottom: "3px" }}>
                    {w}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}

      {/* AI Screening — generate a voice screening test from this JD + master resume */}
      <ScreeningPanel optimization={opt} />
    </div>
  );
}
